<template>
    <div class="deep-wrap section-wrap">
        <Collapse v-model="deep_value">
            <template v-for="(item,index) in cal_deep">
                <div class="group-title" v-if="item.deep_key==='W15'">撞色选择</div>
                <div class="group-title" v-if="item.deep_key==='T1'">外观工艺</div>
                <div class="group-title" v-if="item.deep_key==='V7'">内里工艺</div>
                <div class="group-title" v-if="item.deep_key==='X17'">手工</div>
                <div class="group-title" v-if="item.deep_key==='FD21'">其他工艺</div>
                <Panel :name="item.deep_name" :key="'deep-list-'+index">
                    <template v-if="item.deep_key==='W15'">
                        <div class="deep-title">
                            <span class="title">{{ item.deep_name}}</span>
                            <span class="value">{{ zs_buwei_list.map(v=>v.text).join(',') }}</span>
                        </div>
                        <div slot="content" class="cate-box">
                            <template v-for="oItem in item.option_list">
                                <div class="cate" @click="choose_zs(oItem)"
                                     :class="{'cate-active':zs_buwei_list.map(v=>v.text).includes(oItem.text),'select-active':zs_buwei_list.map(v=>v.text).includes(oItem.text)}">
                                    <div class="img">
                                        <Icon type="ios-information-circle-outline" class="magnifier" size="20" @click.stop="mag(oItem.image)" />
                                        <img v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'" />
                                    </div>
                                    <div> {{ oItem.text }}</div>
                                </div>
                            </template>
                            <div class="clear"></div>
                        </div>
                    </template>
                    <template v-else-if="item.deep_key==='W16'">
                        <div class="deep-title">
                            <span class="title">{{ item.deep_name}}</span>
                            <span class="value">{{ form_data.zs_fabric_key }}</span>
                        </div>
                        <div slot="content" class="cate-box">
                            <template v-for="oItem in item.option_list">
                                <div class="cate" @click="choose_zs_fabric_key(item.deep_key, item.deep_name,oItem.text,oItem.fabric_key, oItem.material, oItem.color)"
                                     :class="{'cate-active':form_data.zs_fabric_key===oItem.fabric_key,'select-active':form_data.zs_fabric_key===oItem.fabric_key}">
                                    <div class="img">
                                        <Icon type="ios-information-circle-outline" class="magnifier" size="20" @click.stop="mag(oItem.image)" />
                                        <img v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'" />
                                    </div>
                                    <div> {{ oItem.text }}</div>
                                </div>
                            </template>
                            <div class="clear"></div>
                        </div>
                    </template>
                    <template v-else-if="item.deep_key==='X18'">
                        <div class="deep-title">
                            <span class="title">{{ item.deep_name}}</span>
                            <span class="value">{{ tj_buwei_list.map(v=>v.text).join(',') }}</span>
                        </div>
                        <div slot="content" class="cate-box">
                            <template v-for="oItem in item.option_list">
                                <div class="cate" @click="choose_tj(oItem)"
                                     :class="{'cate-active':tj_buwei_list.map(v=>v.text).includes(oItem.text),'select-active':tj_buwei_list.map(v=>v.text).includes(oItem.text)}">
                                    <div class="img">
                                        <Icon type="ios-information-circle-outline" class="magnifier" size="20" @click.stop="mag(oItem.image)" />
                                        <img v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'" />
                                    </div>
                                    <div> {{ oItem.text }}</div>
                                </div>
                            </template>
                            <div class="clear"></div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="deep-title">
                            <span class="title">{{ item.deep_name}}</span>
                            <span class="value">{{ deep_list[item.deep_key] }}</span>
                        </div>
                        <div slot="content" class="cate-box">
                            <template v-for="oItem in  item.option_list">
                                <div class="cate" @click="choose_deep(item.deep_key, item.deep_name, oItem.text, oItem.key)"
                                     :class="{'cate-active':deep_list[item.deep_key]==oItem.text,'select-active':deep_list[item.deep_key]==oItem.text}">
                                    <div class="img">
                                        <Icon type="ios-information-circle-outline" class="magnifier" size="20" @click.stop="mag(oItem.image)" />
                                        <img v-lazy="oItem.image + '?x-oss-process=image/resize,w_200,h_200,m_pad,color_FFFFFF'" />
                                    </div>
                                    <div> {{ oItem.text }}</div>
                                </div>
                            </template>
                            <div class="clear"></div>
                        </div>
                    </template>
                </Panel>
            </template>
        </Collapse>
    </div>

</template>

<script>
    import {mapState} from 'vuex'
    export default {
        name: "Deep",
        data() {
            return {
                part: [],
                deep_value: [],
                cal_part: [],
                cal_deep: [],
                relate_map_part: new Map(),
                relate_map_deep: new Map(),
                interval_id: null
            }
        },
        computed: {
            ...mapState({
                part_list: (state) => state.mtm.form_data.part_list,
                deep: (state) => state.mtm.picked_category.hasOwnProperty('deep') ? state.mtm.picked_category.deep : Array.of(),
                deep_list: (state) => state.mtm.form_data.deep_list,
                zs_buwei_list: (state) => state.mtm.form_data.zs_buwei_list,
                tj_buwei_list: (state) => state.mtm.form_data.tj_buwei_list,
                form_data: (state) => state.mtm.form_data,
            }),
        },
        methods: {
            mag(src) {
                this.$viewerApi({
                    options: {
                        title: false,
                        navbar: false,
                        movable: false,
                    },
                    images: [src],
                })
            },
            choose_deep(deep_key, deep_name, option_name, option_key) {
                this.$store.commit('mtm/choose_deep', {
                    deep_key,  deep_name, option_name, option_key
                })

                if(deep_key === 'Y24') {
                }
                // 修改被影响的选项
                if(this.relate_map_deep.has(option_key)) {
                    // 每个关联显示的部位

                    for(let key_self in this.relate_map_deep.get(option_key)) {

                        // 自身配置里能显示的选项
                        let filter_option_list = this.relate_map_deep.get(option_key)[key_self]
                        // 寻找其他部位选中项可能对当前的影响
                        for(let key_another in this.deep_list) {
                            let part_another = this.deep.find(v=>v.deep_key === key_another)
                            let relate_another = part_another.option_list.find(v=>v.text==this.deep_list[key_another])
                            // 寻找其他部位选中项是否有relate_part对当前的影响
                            let ldd = {option_list: (relate_another && this.relate_map_deep.has(relate_another.key) && this.relate_map_deep.get(relate_another.key)[key_self] ? this.relate_map_deep.get(relate_another.key)[key_self] : [])}
                            if(ldd.option_list.length === 0) {
                                continue;
                            }
                            let sa = Array.from(new Set(filter_option_list.map(v => v.text)));
                            let sb = Array.from(new Set(ldd.option_list.map(v => v.text)));
                            let intersect_keys = sa.filter(x => sb.includes(x));
                            filter_option_list = filter_option_list.filter(v=>intersect_keys.includes(v.text))
                            filter_option_list = [...new Map(filter_option_list.map(v => [v.text, v])).values()]
                        }


                        if((this.deep.map(v=>v.deep_key)).includes(key_self)) {
                            let idx = this.deep.findIndex((v) => {
                                return v.deep_key === key_self
                            })
                            if(idx === -1) {
                                continue;
                            }

                            // 填充计算后选项
                            this.$set(this.cal_deep[idx], 'option_list', filter_option_list)
                            // 统一清除关联项重新选择
                            this.$store.commit('mtm/clear_deep', {
                                deep_key: key_self
                            })
                        }

                    }
                }

                let idx = this.deep_value.findIndex(v=>v===deep_name)
                this.deep_value.splice(idx, 1)
            },
            choose_zs(option) {
                this.$store.commit('mtm/choose_zs', {
                    option
                })
            },
            choose_zs_fabric_key(deep_key, deep_name, option_name, fabric_key, material, color) {
                this.choose_deep(deep_key, deep_name, option_name, null)
                this.$store.commit('mtm/choose_zs_fabric_key', {
                    key: fabric_key,
                    material, color
                })
            },
            choose_tj(option) {
                this.$store.commit('mtm/choose_tj', {
                    option
                })
            }
        },
        destroyed() {
            clearInterval(this.interval_id)
        },
        mounted() {
            let category = JSON.parse(localStorage.getItem('category') || '{}')
            this.part = category.part || []

            this.cal_part = this.part
            for(let j in this.part) {
                let o1 = this.part[j].option_list
                for(let k in o1) {
                    let o2 = this.part[j].option_list[k]
                    if(!o2.hasOwnProperty('relate_part')) {
                        continue
                    }
                    let obj = {}
                    for(let i in o2.relate_part) {
                        let o3 = o2.relate_part[i]
                        obj[o3.category_key] = o3.option_list
                    }
                    this.relate_map_part.set(o2.part_key, obj)
                }
            }
            this.cal_deep = category.deep || []
            for(let j in this.deep) {
                let o1 = this.deep[j].option_list
                for(let k in o1) {
                    let o2 = this.deep[j].option_list[k]
                    if(!o2.hasOwnProperty('relate_part')) {
                        continue
                    }
                    let obj = {}
                    for(let i in o2.relate_part) {
                        let o3 = o2.relate_part[i]
                        obj[o3.deep_key] = o3.option_list
                    }
                    this.relate_map_deep.set(o2.key, obj)
                }
            }
            // 展开Collapse
            for (let index_outer in this.deep) {
                // this.deep_value.push(this.deep[index_outer].deep_name)
            }

            // 第一次进页面
            if(Object.keys(this.deep_list).length === 0) {
                for (let index_outer in this.deep) {
                    let deep_item = this.deep[index_outer]
                    if(deep_item.option_list.length > 0 && deep_item.deep_key != 'W15' && deep_item.deep_key != 'W16' && deep_item.deep_key != 'X18') {
                        let first_option = deep_item.option_list[0]
                        this.choose_deep(deep_item.deep_key,deep_item.deep_name,first_option.text, first_option.key)
                    }

                }
            }

            this.interval_id = setInterval(() => {
                let deep_key_arr = this.deep.map(v=>v.deep_key)
                for(let index in deep_key_arr) {
                    let key_self = deep_key_arr[index]
                    let options_arr = Array.of();
                    let flag = false
                    // 寻找其他部位选中项可能对当前的影响
                    for(let key_another in this.part_list) {

                        let part_another = this.part.find(v=>v.category_key === key_another)

                        let relate_another = part_another.option_list.find(v=>v.part_name_cn==this.part_list[key_another])
                        // 寻找其他部位选中项是否有relate_part对当前的影响
                        let ldd = {option_list: (relate_another && this.relate_map_part.has(relate_another.part_key) && this.relate_map_part.get(relate_another.part_key)[key_self] ? this.relate_map_part.get(relate_another.part_key)[key_self] : [])}
                        if(ldd.option_list.length === 0) {
                            continue;
                        }
                        let sb = Array.from(new Set(ldd.option_list));
                        options_arr = [...options_arr, ...sb]
                        options_arr = Array.from(new Set(options_arr.map(item => JSON.stringify(item)))).map(item => JSON.parse(item));
                        flag = true
                    }
                    if(flag === false) {
                        continue;
                    }


                    let filter_option_list = options_arr.map(v => {
                        return {
                            text: v.part_name_cn,
                            image: v.image,
                            key: v.part_key
                        }
                    })

                    if((this.deep.map(v=>v.deep_key)).includes(key_self)) {
                        let idx = this.deep.findIndex((v) => {
                            return v.deep_key === key_self
                        })

                        // 填充计算后选项
                        this.$set(this.cal_deep[idx], 'option_list', filter_option_list)

                        if(!((filter_option_list.map(v=>v.text)).includes(this.deep_list[key_self])) && this.deep_list[key_self] !== undefined) {
                            this.$store.commit('mtm/clear_deep', {
                                deep_key: key_self
                            })
                        }

                        if(key_self === 'X18') {
                            let sa = Array.from(new Set(this.tj_buwei_list.map(v => v.text)));
                            let sb = Array.from(new Set(filter_option_list.map(v => v.text)));
                            let diff_keys = sa.filter(x => !sb.includes(x));
                            for(let k=0;k<diff_keys.length;k++) {

                                this.$store.commit('mtm/clear_tj', diff_keys[k])
                            }
                        }
                        if(key_self === 'W15') {
                            let sa = Array.from(new Set(this.zs_buwei_list.map(v => v.text)));
                            let sb = Array.from(new Set(filter_option_list.map(v => v.text)));
                            let diff_keys = sa.filter(x => !sb.includes(x));
                            for(let k=0;k<diff_keys.length;k++) {
                                this.$store.commit('mtm/clear_zs', diff_keys[k])
                            }
                        }
                    }
                }

            }, 500)
        },
    }
</script>

<style lang="scss" scoped>
    .group-title {
        font-weight: bolder;
        font-size: 18px;
        margin: 0.5vw 0 -1vw;
        text-align: center;
    }
    .deep-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 10px;
        .value {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 10px;
            color: #666666;
        }
    }
    .cate-box {
        margin: 30px 0;
        display: flex;
        flex-wrap: wrap;
        .cate {
            font-size: 15px;
            font-weight: 400;
            color: #666666;
            width: 130px;
            text-align: center;
            margin-bottom: 15px;
            margin-right: 8px;
            cursor: pointer;
            .img {
                position: relative;
                background: #ffffff;
                border: 1px solid #dddddd;
                opacity: 1;
                border-radius: 2px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 5px;
                .magnifier{
                    position: absolute;
                    bottom:5px;
                    right:5px;
                }
            }
        }
        .cate-active {
            font-weight: bold;
            color: #0f114a;
            .img {
                border: 1px solid #0f114a;
            }
        }
    }

    .no3d {
        .cate-box {
            .cate {
                .img {

                }
            }
        }
    }
    .select-active {
        position: relative;
    }
    .select-active:after {
        background-image: url("~@/assets/images/design/select@2x.png");
        background-size: 100%;
        width: 13px;
        height: 13px;
        position: absolute;
        right: 5px;
        top: 5px;
        content: "";
    }
</style>
